import React from 'react'
import PropTypes from 'prop-types'

import PageWrapupHeader from 'src/ui/PageWrapup/subcomponents/PageWrapupHeader/PageWrapupHeader'

import flashcardsImage from './assets/flashcards.svg'
import mediaImage from './assets/media.svg'
import writingImage from './assets/writing.svg'
import readingImage from './assets/reading.svg'
import conceptImage from './assets/concept.svg'

const IMAGES_MAP = {
  flashcards: flashcardsImage,
  review: flashcardsImage,
  video: mediaImage,
  audio: mediaImage,
  writing: writingImage,
  reading: readingImage,
  concept: conceptImage,
}

const ActivityWrapupHeader = ({ activityType, onlyLogo }) => {
  const image = IMAGES_MAP[activityType]

  return <PageWrapupHeader backgroundImage={onlyLogo ? null : image} />
}

ActivityWrapupHeader.propTypes = {
  activityType: PropTypes.oneOf([
    'flashcards',
    'review',
    'reading',
    'writing',
    'video',
    'audio',
    'concept',
  ]).isRequired,
  onlyLogo: PropTypes.bool,
}

export default ActivityWrapupHeader
